module.exports = __webpack_public_path__ + "390ac6e6e92619932392b9f3b236ca83.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-icons/icon-mushrooms.png
// module id = 3457
// module chunks = 0